import { VariableType } from '../../../components/Table/types'

export const internalKeyFigureTypes = ['absolute', 'percentage', 'ratio'] as VariableType[]

export const budgetDriverKeyFigureTypes = ['absolute', 'percentage']
